var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneIconRecovery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.5353 4H21.6304C18.5864 4 16 6.48201 16 9.52517V51.4811C16 54.5243 18.5317 57 21.5757 57L39.5101 56.9806C42.5537 56.9806 45.0437 54.5045 45.0437 51.4609L45.0698 9.52223C45.0694 6.46812 42.5916 4 39.5353 4ZM27.9963 7.31258H33.191C33.6473 7.31258 34.019 7.68303 34.019 8.14062C34.019 8.59821 33.6473 8.96866 33.191 8.96866H27.9963C27.5387 8.96866 27.1682 8.59821 27.1682 8.14062C27.1682 7.68303 27.5387 7.31258 27.9963 7.31258ZM24.8748 7.5761C25.1817 7.26964 25.7403 7.26543 26.0468 7.5761C26.2004 7.72933 26.2913 7.94445 26.2913 8.16419C26.2913 8.37973 26.2004 8.59442 26.0468 8.74807C25.894 8.90172 25.678 8.99223 25.4629 8.99223C25.2436 8.99223 25.0327 8.90172 24.8748 8.74807C24.722 8.59484 24.6348 8.37973 24.6348 8.16419C24.6344 7.94445 24.722 7.72933 24.8748 7.5761ZM30.4265 55.3587C29.06 55.3587 27.9487 54.2465 27.9487 52.8804C27.9487 51.514 29.06 50.4022 30.4265 50.4022C31.7929 50.4022 32.9043 51.514 32.9043 52.8804C32.9043 54.2465 31.7925 55.3587 30.4265 55.3587ZM42.4994 48.7179H18.8983V11.8674H42.4994V48.7179Z",
    fill: "#6A75CA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIconRecovery);
export default __webpack_public_path__ + "static/media/phoneIconRecovery.98d9a2f5bb79048c487d0ef37656335e.svg";
export { ForwardRef as ReactComponent };